export const TOKEN_TYPE = "Token ";
export const REQUEST_HEADER_AUTH_KEY = "Token";

export const APIS = {
  GET_DASHBOARD_DETAILS: "/admin/dashboard",
  USERS: "/admin/emails",
  CHANGE_PASSWORD: "/admin/changePassword",
  USERS_LIST: "/admin/users",
  DELETE_USER: "/admin/deleteUser",
  BLOCK_USER: "/admin/enableDisableUser",
  PROPERTY_LIST: "/admin/propertyList",
  PROPERTY_DETAILS: "/admin/propertyDetails",
  USER_DETAILS: "/admin/getUser",
  UPDATE_USER: "/admin/updateUser",
  TOGGLE_PROPERTY_STATUS: "/admin/actionOnProperty",
  LIST_SECTIONS: "/admin/listSections",
  CREATE_SECTION: "/admin/createSection",
  DELETE_SECTION: "/admin/deleteSection",
  UPDATE_LIST_SECTIONS: "/admin/updateSection",
  TOGGLE_LIST_SECTION: "/admin/toggleSection",
  RECODER_LIST_SECTION: "/admin/reorderSection",
  CATEGORIES: "/admin/categoryTree",
  CATEGORY_BY_ID: "/admin/getCategory",
  TOGLLE_CATEGORIES: "/admin/toggleCategory",
  DELETE_CATEGORY: "/admin/deleteCategory",
  UPLOAD: "/admin/upload",
  UPDATE_CAYEGORY: "/admin/updateCategory",
  SET_MARKUP: "/admin/setMarkup",
  CREATE_CATEGORY: "/admin/createCategory",
  SEARCH_ENTRIES: "/admin/searchEntries",
  DELETE_SEARCH_ENTRY: "/admin/searchEntries",
  PROFILE: "/admin/profile",
  EDIT_PROFILE: "/admin/edit",
  REORDER_SECTION: "/admin/reorderSection",
  SETTINGS: "/admin/settings",
  SHIPPING: "/admin/orderItems",
  EDIT_SETTING: "/admin/editSetting",
  QUERY: "/admin/queries",
  UPDATE_QUERY: "/admin/updateQuery",
  TRANSACTIONS: "/admin/transactions",
  SHEETS: "/admin/getSheets",
  UPLOAD_SHEET: "/admin/uploadSheet",
  REPLACE_SHEET: "/admin/replaceSheet",
  DELETE_SHEET: "/admin/deleteSheet",
  FILES: "/admin/files",
  UPDATE_FILES: "/admin/fileStatusUpdate",
  USER_CATEGORY: "/admin/userCategories",
  CREATE_USER_CATEGORY: "/admin/createUserCategory",
  UPDATE_USER_CATEGORY: "/admin/updateUserCategory",
  TOGGLE_USER_CATEGORY: "/admin/toggleUserCategory",
  ORDERS: "/admin/orders",
  ORDER_ID: "/admin/orderDetail",
  COMPONENT: "/admin/components",
  UPDATE_COMPOENT: "/admin/updateComponent",
  COMPONENT_DETAILS: "/admin/componentDetail",
  BRANDS: "/admin/brands",
  DELETE_BRAND: "/admin/deleteBrand",
  ADD_SUB_ADMIN: "/admin/addSubAdmin",
  SUB_ADMIN_LIST: "/admin/subAdminList",
  DELETE_SUB_ADMIN: "/admin/deleteSubAdmin",
  UPDATE_SUB_ADMIN: "/admin/updateSubAdmin",
  VEHICLES: "/admin/getVehicles",
  CREATE_VEHICLE: "/admin/createVehicle",
  DELETE_VEHICLE: "/admin/deleteVehicle",
  UPDATE_VEHICLE: "/admin/updateVehicle",
  VEHICLE_DETAILS: "/admin/getVehicleById",
  DASBOARD_ORDERS: "/admin/dashboardOrders",
  TAXES: "/admin/getTaxes",
  UPDATE_TAXES: "/admin/updateTax",
  CREATE_TAXES: "/admin/createTax",
  DELETE_TAXES: "/admin/deleteTax",
  EXPORT_USER: "/admin/exportUsers",
  EXPORT_ORDERS: "/admin/exportOrders",
  EXPORT_TRANSACTIONS: "/admin/exportTransactions",
  EXPORT_BRANDS: "/admin/exportBrands",
  EXPORT_SUPPLIERS: "/admin/exportSuppliers",
  EXPORT_ORDER_LINES: "/admin/exportOrderLineItems",
  EXPORT_DAILY_SUMMARY: "/admin/exportDailySummary",
  TABLE_PRODUCTS: "/admin/taxableProducts",
  "UPLOAD_TRANSLATION": "/admin/uploadTranslations",
  "UPLOAD_REGISTRY": "/admin/importRegistry",
  "UPLOAD_MULTIPLE_FILES": "/admin/uploadFiles",
  "TOGGLE_PORTER_STATUS": "/admin/updateShippingStatus",
  TOGGLEVEHICLE: "/admin/enableDisableVehicle",
  SUPPLIER_STATISTICS: "/admin/getSupplierStatistics",
  SUPPLIER_ORDER: "/admin/supplierOrders",
  PAYALBLE_SUPPLIERS: "/admin/getPendingPayableOrders/",
  SETTLEHISTORY: "/admin/getSettlementHistory",
  SETTLEORDERS: "/admin/settleOrders",
  GET_SETTLEMENT:"/admin/getSettlement",
  GET_COUNT:"/admin/menuCount",
  UPDATE_TOKEN: "/admin/updateToken",
  PRODUCT_LIST: "/admin/product/list",
  PRODUCT_DETAIL: "/admin/product/detail",
  PRODUCT_EDIT: "/admin/product/edit",
  SUPPLIER_PRODUCT_APPROVE: "/admin/supplier-product/approve",
};

